import type { TranslationDictionaryType } from "@shared/types/i18n.interface";
import type { AssertMatchingPlaceholders } from "@shared/types/translation-key.types";

import type { en } from "./en";

export const es = {
  "user.directory.header.title": "Directorio del evento",
  "user.directory.header.account": "Tu cuenta",
  "user.directory.defaultEventName": "Evento",

  "user.directory.tabs.all": "Todos",
  "user.directory.tabs.topPicks": "Sugerencias",
  "user.directory.tabs.requests": "Solicitudes",
  "user.directory.tabs.connected": "Conectados",

  "user.directory.loadingMore": "Cargando más…",
  "user.directory.search.placeholder": "Buscar participantes",
  "user.directory.search.placeholderWithCountOne": "Buscar 1 participante",
  "user.directory.search.placeholderWithCount":
    "Buscar {{count}} participantes",
  "user.directory.search.clear": "Borrar búsqueda",
  "user.directory.search.groups.names": "Por nombre, cargo o empresa",
  "user.directory.search.groups.meaning": "Por lo que hacen",
  "user.directory.search.groups.reading": "Leyendo {{count}} perfiles",
  "user.directory.search.groups.readingOne": "Leyendo 1 perfil",
  "user.directory.search.groups.seeAll": "Ver los {{count}}",
  "user.directory.list.you": "Tú",
  "user.directory.index.railLabel": "Saltar a una letra",

  "user.directory.topPicks.banner.title": "Mira tus sugerencias →",
  "user.directory.topPicks.banner.subtitle":
    "O explora los {{count}} perfiles (tiempo estimado de lectura {{time}})",
  "user.directory.topPicks.banner.subtitleOne":
    "O explora el único perfil (tiempo estimado de lectura {{time}})",
  "user.directory.topPicks.banner.dismiss": "Cerrar banner",

  "user.directory.topPicks.info.description":
    "A quién Porter cree que deberías conocer.",
  "user.directory.topPicks.info.recalculating":
    "Estas son las sugerencias que tenía antes, por si quieres verlas.",

  "user.directory.topPicks.recalculating.title": "Preguntando por ahí",
  "user.directory.topPicks.recalculating.subtitle":
    "Estoy viendo con quién podrías tener una conversación interesante. Te escribo cuando tenga las nuevas.",

  "user.directory.topPicks.generateMore": "Buscar más",
  "user.directory.topPicks.generating": "Buscando…",

  "user.directory.topPicks.isolatedGate.buttonLabel": "Buscar más",
  "user.directory.topPicks.isolatedGate.legal":
    "Planta te ayuda a hacer conexiones memorables en eventos. Al volverte miembro activas tu red y guardas tu perfil para eventos futuros. Al hacer clic te unes como miembro y aceptas los {{terms}} y la {{privacy}}.",
  "user.directory.topPicks.isolatedGate.termsLabel": "Términos",
  "user.directory.topPicks.isolatedGate.privacyLabel": "Política de Privacidad",
  "user.directory.topPicks.isolatedGate.error":
    "Algo salió mal. Intenta de nuevo.",
  "user.directory.empty.all.title": "Todavía no hay nadie en la sala.",
  "user.directory.empty.all.description":
    "Los nombres van apareciendo aquí a medida que la gente se suma. Llegaste temprano.",

  "user.directory.empty.topPicks.title": "Estoy preguntando por ahí",
  "user.directory.empty.topPicks.description":
    "Cada persona aquí tiene su propio Porter. Le estoy pasando la pregunta a algunos, en voz baja.",
  "user.directory.empty.topPicks.note":
    "Lo que sale es la pregunta, no tú. Te aviso cuando vuelva alguien que valga tu noche.",
  "user.directory.empty.topPicks.browse": "Mira la sala mientras tanto",
  "user.directory.empty.browse": "Mira la sala",

  "user.directory.empty.requests.description":
    "Cuando alguien pida conocerte, aparece aquí. También puedes dar el primer paso, desde cualquier perfil.",
  "user.directory.empty.connected.description":
    "Cuando los dos digan que sí, sus datos aparecen aquí. Antes de eso no se comparte nada.",
  "user.directory.empty.requests.title": "Todavía nadie preguntó por ti.",

  "user.directory.empty.sentRequests.title": "Nada pendiente.",
  "user.directory.empty.sentRequests.description":
    "Pide conocer a alguien y lo ves aquí, con cómo va.",

  "user.directory.empty.connected.title": "Todavía no hay conexiones.",

  "user.directory.empty.search.title": "Aquí no está.",
  "user.directory.empty.search.description":
    'Nadie aquí coincide con "{{query}}". Busca por nombre, empresa o cargo. Para saber a quién conocer, pregúntale a Porter por WhatsApp.',

  "user.directory.error.title": "Algo salió mal",
  "user.directory.error.description":
    "No pudimos cargar el directorio. Por favor, intenta de nuevo.",
  "user.directory.error.networkTitle": "Problema de conexión",
  "user.directory.error.networkDescription":
    "Revisa tu conexión a internet e intenta de nuevo.",
  "user.directory.error.retryButton": "Reintentar",
  "user.directory.error.retrying": "Reintentando…",

  "user.directory.profile.at": "en",

  "user.directory.requests.fullProfile": "Perfil completo",
  "user.directory.requests.accept": "Aceptar",
  "user.directory.requests.accepting": "Aceptando…",
  "user.directory.requests.ignore": "Ignorar",
  "user.directory.requests.ignoring": "Ignorando…",
  "user.directory.requests.undo": "Deshacer",
  "user.directory.requests.status.accepted":
    "Aceptada • Info de contacto compartida",
  "user.directory.requests.status.ignored": "Ignorada",
  "user.directory.requests.requestedAgo": "Solicitado {{time}}",

  "user.directory.requests.sentLink": "Enviadas",
  "user.directory.requests.sentLinkLabel":
    "Enviadas: ver las solicitudes que enviaste",
  "user.directory.requests.sent.title": "Tus solicitudes enviadas",
  "user.directory.requests.sent.back": "Atrás",
  "user.directory.requests.sent.sentAgo": "Enviada {{time}}",
  "user.directory.requests.sent.connected": "Conectados",

  "user.directory.profile.back": "Atrás",
  "user.directory.profile.backToDirectory": "Directorio",
  "user.directory.profile.tabs.profile": "Perfil",
  "user.directory.profile.tabs.whyConnect": "Por qué conectar",
  "user.directory.profile.linkedin.currently": "Actualmente",
  "user.directory.profile.linkedin.previously": "Anteriormente",
  "user.directory.profile.linkedin.summary": "Acerca de",
  "user.directory.profile.linkedin.notAvailableFromInfo":
    "No disponible con la información proporcionada",
  "user.directory.profile.whyConnect.noReasons":
    "Las razones para conectar no están disponibles.",
  "user.directory.profile.editProfile": "Editar perfil",
  "user.directory.profile.cta.requestIntro": "Solicitar intro",
  "user.directory.profile.cta.requesting": "Solicitando...",
  "user.directory.profile.cta.requestIntroHelp":
    "Si tu solicitud es aceptada o aprobada por el anfitrión, ambos recibirán la información de contacto del otro.",
  "user.directory.profile.cta.requested": "Solicitada",
  "user.directory.profile.cta.requestedHelp":
    "Le hemos notificado de tu solicitud",
  "user.directory.profile.cta.ignored": "Ignorada",
  "user.directory.profile.cta.ignoredHelp": "Ya ignoraste su solicitud",
  "user.directory.profile.cta.accept": "Aceptar",
  "user.directory.profile.cta.accepting": "Aceptando…",
  "user.directory.profile.cta.ignore": "Ignorar",
  "user.directory.profile.cta.inboundHelp": "Solicitó una intro {{date}}",
  "user.directory.profile.cta.email": "Copiar email",
  "user.directory.profile.cta.whatsapp": "Abrir WhatsApp",
  "user.directory.profile.cta.emailNotShared": "Email no compartido",
  "user.directory.profile.cta.whatsappNotShared": "WhatsApp no compartido",
  "user.directory.profile.cta.connectedOn": "Conectados el {{date}}",
  "user.directory.profile.error.title": "Algo salió mal",
  "user.directory.profile.error.description":
    "No pudimos cargar este perfil. Intenta de nuevo.",
  "user.directory.profile.error.retry": "Reintentar",
  "user.directory.profile.notFound.title": "Perfil no encontrado",
  "user.directory.profile.notFound.description":
    "Este perfil podría ya no estar disponible.",
  "user.directory.profile.error.sendRequest":
    "No se pudo enviar la solicitud. Por favor, intenta de nuevo.",
  "user.directory.profile.error.acceptRequest":
    "No se pudo aceptar la solicitud. Por favor, intenta de nuevo.",
  "user.directory.profile.error.ignoreRequest":
    "No se pudo ignorar la solicitud. Por favor, intenta de nuevo.",
  "user.directory.profile.error.respondRequest":
    "No se pudo responder a la solicitud. Por favor, intenta de nuevo.",

  "user.directory.toast.introRequested": "Intro solicitada",
  "user.directory.toast.introRequestedDescription":
    "Hemos notificado a {{name}} de tu solicitud",
  "user.directory.toast.connected": "Conectado con {{name}}",
  "user.directory.toast.connectedDescription":
    "Ahora pueden ver la información de contacto del otro.",
  "user.directory.toast.requestDeclined": "Solicitud ignorada",
  "user.directory.toast.requestDeclinedDescription":
    "La solicitud ha sido ignorada",
  "user.directory.toast.rateLimitExceeded": "Límite de intros alcanzado",
  "user.directory.toast.rateLimitExceededDescription":
    "Puedes enviar hasta {{limit}} solicitudes de intro cada {{window}}. Intenta más tarde.",
  "user.directory.toast.requestIntroFailed": "No se pudo enviar la solicitud",
  "user.directory.toast.requestIntroFailedDescription":
    "Por favor, intenta más tarde",
  "user.directory.toast.respondFailed": "No se pudo responder",
  "user.directory.toast.respondFailedDescription":
    "Por favor, intenta más tarde",
  "user.directory.toast.noRequestId": "No se puede procesar la solicitud",
  "user.directory.toast.noRequestIdDescription":
    "No se encontró la solicitud. Por favor, recarga la página.",
  "user.directory.toast.emailCopied": "Email copiado",
  "user.directory.toast.emailCopiedDescription":
    "Dirección de email copiada al portapapeles",
  "user.directory.toast.emailCopyFailed": "No se pudo copiar el email",
  "user.directory.toast.emailCopyFailedDescription":
    "No se pudo copiar la dirección de email al portapapeles",
  "user.directory.toast.noEmailAvailable": "Email no disponible",
  "user.directory.toast.noEmailAvailableDescription":
    "Este contacto no tiene una dirección de email registrada",
  "user.directory.toast.noPhoneAvailable": "Teléfono no disponible",
  "user.directory.toast.noPhoneAvailableDescription":
    "Este contacto no tiene un número de teléfono registrado",

  "user.directory.profile.requestIntroModal.title":
    "Agrega una nota a la solicitud",
  "user.directory.profile.requestIntroModal.placeholder":
    "Cuéntale a {{name}} por qué quieres conectar",
  "user.directory.profile.requestIntroModal.placeholderGeneric":
    "Cuéntale por qué quieres conectar",
  "user.directory.profile.requestIntroModal.charCount":
    "{{current}}/{{max}} caracteres",
  "user.directory.profile.requestIntroModal.messageHint":
    "No se permiten saltos de línea.",
  "user.directory.profile.requestIntroModal.send": "Enviar",
  "user.directory.profile.requestIntroModal.sending": "Enviando...",
  "user.directory.profile.requestIntroModal.close": "Cerrar",

  "user.error.generic.title": "Algo salió mal",
  "user.error.generic.description":
    "Ocurrió un error inesperado. Por favor, intenta de nuevo.",
  "user.error.notFound.title": "Página no encontrada",
  "user.error.notFound.description": "La página que buscas no existe.",
  "user.error.server.title": "Error del servidor",
  "user.error.server.description":
    "Algo salió mal de nuestro lado. Por favor, intenta más tarde.",
  "user.error.retryButton": "Reintentar",
  "user.error.homeButton": "Ir al inicio",

  "user.profile.title": "Tu perfil",
  "user.profile.photo.title": "Tu foto",
  "user.profile.photo.initialsHint":
    "Las iniciales son lo que ven los demás hasta que agregues una.",
  "user.profile.photo.currentHint": "Esto es lo que ven los demás.",
  "user.profile.photo.choose": "Elige una foto",
  "user.profile.photo.chooseAnother": "Elige otra",
  "user.profile.photo.takeNow": "Tómate una ahora",
  "user.profile.photo.remove": "Quitar la foto",
  "user.profile.photo.whyTitle": "Por qué importa",
  "user.profile.photo.whyBody":
    "Entre el 76 y el 90 por ciento de los invitados llegan con foto. La tuya es lo primero que alguien mira antes de decir que sí.",
  "user.profile.header.directory": "Directorio",
  "user.profile.header.account": "Cuenta",
  "user.profile.header.switchEvent": "Cambiar evento",

  "user.profile.tabs.profile": "Perfil",
  "user.profile.tabs.preferences": "Preferencias",

  "user.profile.comingSoon":
    "La gestión de perfil aún no está disponible. Próximamente.",

  "user.profile.preferences.notifications": "Notificaciones",
  "user.profile.preferences.incomingRequests": "Solicitudes recibidas",
  "user.profile.preferences.acceptedRequests": "Solicitudes aceptadas",
  "user.profile.preferences.contactSharing": "Compartir contacto",
  "user.profile.preferences.eventNotifications": "Notificaciones del evento",
  "user.profile.preferences.eventNotificationsDescription":
    "Mensajes de Porter sobre el evento, aparte de tus solicitudes.",
  "user.profile.preferences.whatsapp": "WhatsApp",
  "user.profile.preferences.email": "Email",
  "user.profile.preferences.realTime": "Tiempo real",
  "user.profile.preferences.off": "Desactivado",
  "user.profile.preferences.contactSharingDescription":
    "Elige la información de contacto que la otra persona recibe cuando se conectan.",
  "user.profile.preferences.contactSharingError":
    "Elige al menos una. Solo se comparte cuando ambos aceptan.",
  "user.profile.preferences.errorLoading":
    "No se pudieron cargar las preferencias. Por favor, intenta de nuevo.",
  "user.profile.preferences.errorSaving":
    "No se pudieron guardar las preferencias. Por favor, intenta de nuevo.",
  "user.profile.preferences.futureEvents.title": "Eventos futuros",
  "user.profile.preferences.futureEvents.buttonRemember":
    "Recordarme para eventos futuros",
  "user.profile.preferences.futureEvents.buttonRemembered":
    "Recordado para eventos futuros",
  "user.profile.preferences.futureEvents.description":
    "Planta te ayuda a mantener el contacto con las personas que conociste, descubrir nuevas y construir tu historial de conexiones entre eventos (no solo LTF). Planta es independiente de LTF y Riverwood. Al hacer clic, te conviertes en miembro, o si ya eres parte de Planta, esta información se suma a tu registro — potenciando tu perfil para el próximo evento. Aceptas los {{terms}} y la {{privacy}}.",
  "user.profile.preferences.futureEvents.termsLabel": "Términos",
  "user.profile.preferences.futureEvents.privacyLabel":
    "Política de Privacidad",
  "user.profile.preferences.export.sectionLabel": "Directorio",
  "user.profile.preferences.export.title": "Exportar el directorio",
  "user.profile.preferences.export.description":
    "Te envía por WhatsApp a todos los participantes del directorio en una hoja de cálculo: nombre, cargo, bio, resumen de LinkedIn, Por qué conectar y LinkedIn. No incluye correos electrónicos ni teléfonos de nadie.",
  "user.profile.preferences.export.descriptionNoWhyConnect":
    "Te envía por WhatsApp a todos los participantes del directorio en una hoja de cálculo: nombre, cargo, bio, resumen de LinkedIn y LinkedIn. No incluye correos electrónicos ni teléfonos de nadie.",
  "user.profile.preferences.export.button": "Enviar por WhatsApp",
  "user.profile.preferences.export.modal.title": "¿Enviar el directorio?",
  "user.profile.preferences.export.modal.body":
    "Porter te va a enviar el directorio en una hoja de cálculo por WhatsApp.",
  "user.profile.preferences.export.modal.confirm": "Enviar",
  "user.profile.preferences.export.modal.cancel": "Cancelar",
  "user.profile.preferences.export.modal.sending": "Enviando…",
  "user.profile.preferences.export.modal.queuedTitle": "En camino",
  "user.profile.preferences.export.modal.queuedBody":
    "Porter te está enviando el directorio por WhatsApp. Abre tu chat con Porter para encontrarlo.",
  "user.profile.preferences.export.modal.needsInboundTitle":
    "Escríbele a Porter primero",
  "user.profile.preferences.export.modal.needsInboundBody":
    "WhatsApp solo permite que Porter te envíe un archivo dentro de las 24 horas posteriores a tu último mensaje. Escríbele a Porter y vuelve a intentar.",
  "user.profile.preferences.export.modal.errorBody":
    "Hubo un problema al enviar el directorio. Por favor, intenta de nuevo.",
  "user.profile.preferences.export.modal.close": "Cerrar",

  "user.profile.form.addPhoto": "Agrega una foto",
  "user.profile.form.changePhoto": "Cambiar foto",
  "user.profile.form.uploading": "Subiendo…",
  "user.profile.form.removePhoto": "Quitar",
  "user.profile.form.removing": "Quitando…",
  "user.profile.form.firstName": "Nombre",
  "user.profile.form.lastName": "Apellido",
  "user.profile.form.fullName": "Nombre completo",
  "user.profile.form.nickName": "Apodo",
  "user.profile.form.title": "Cargo",
  "user.profile.form.titlePlaceholder": "Tu título profesional",
  "user.profile.form.company": "Empresa",
  "user.profile.form.bio": "Resumen bio",
  "user.profile.form.bioPlaceholder": "Cuéntales a otros sobre ti",
  "user.profile.form.summary": "Resumen de LinkedIn",
  "user.profile.form.summaryPlaceholder": "Tu resumen de LinkedIn",
  "user.profile.form.whatPeopleSee": "Lo que ven los demás",
  "user.profile.form.porterReads":
    "Porter lee esto para decidir a quién traerte. Nada llega a nadie hasta que tú aceptes.",
  "user.profile.form.save": "Guardar",
  "user.profile.form.saving": "Guardando…",
  "user.profile.form.openInDirectory": "Abrir en el directorio",
  "user.profile.form.errorLoading":
    "No se pudieron cargar los datos del perfil. Por favor, intenta de nuevo.",
  "user.profile.form.errorSaving":
    "No se pudieron guardar los cambios. Por favor, intenta de nuevo.",
  "user.profile.form.errorMissingId":
    "Falta el ID de participante. Por favor, recarga la página.",
  "user.profile.form.photoTooLarge":
    "La foto es muy grande (máx. {{maxSize}}MB)",
  "user.profile.form.invalidPhotoType":
    "Tipo de foto inválido. Sube una imagen JPEG, PNG o WebP.",
  "user.profile.form.notProvided": "No proporcionado",

  "user.account.header.subtitle": "Cuenta y preferencias",
  "user.account.header.closeLabel": "Cerrar",
  "user.account.header.back": "Atrás",

  "user.account.title": "Tu cuenta Planta",
  "user.account.tabs.settings": "Configuración",
  "user.account.tabs.events": "Eventos",

  "user.account.settings.email": "Email",
  "user.account.settings.whatsapp": "WhatsApp",
  "user.account.settings.linkedin": "LinkedIn",
  "user.account.settings.verified": "Verificado",
  "user.account.settings.unverified": "No verificado",
  "user.account.settings.sendVerification": "Enviar código de verificación",
  "user.account.settings.verificationSent": "Enviando código…",
  "user.account.settings.enterCode": "Ingresa el código",
  "user.account.settings.verify": "Verificar",
  "user.account.settings.verifySuccess": "Email verificado.",
  "user.account.settings.verifyError":
    "Falló la verificación. Por favor, intenta de nuevo.",
  "user.account.settings.rateLimited":
    "Demasiados intentos. Por favor, intenta más tarde.",
  "user.account.settings.footer": "Para actualizar estos datos, escribe a",
  "user.account.settings.footerEmail": "help@planta.network",

  "user.account.events.past": "Pasados",
  "user.account.events.noUpcoming": "No hay eventos próximos",
  "user.account.events.noPast": "No hay eventos pasados",

  "user.eventLanding.whatsapp.defaultMessage": "¡Hola Porter!",
  "user.eventLanding.errorState.message":
    "No se pudo cargar la información del evento. Verifica el enlace e inténtalo de nuevo.",
  "user.eventLanding.invalidLink":
    "Enlace de evento inválido. Revisa la URL e inténtalo de nuevo.",
  "user.eventLanding.loadingLabel": "Cargando el evento",
  "user.eventLanding.eyebrow": "@{{eventName}}",
  "user.ltf.invitedBy": "Te invitó {{host}}",
  "user.ltf.poweredBy": "Con tecnología de Planta",
  "user.ltf.hero.suffix": "Tu concierge de conexiones del evento",
  "user.ltf.feature.directory": "Accedé al directorio de participantes.",
  "user.ltf.feature.intros":
    "Pedí presentaciones a otros participantes de LTF y conectá por WhatsApp o email.",
  "user.ltf.feature.materials":
    "Accedé a la agenda, el mapa del evento, las lecturas previas y más.",
  "user.ltf.cta.openWhatsapp": "Abrí LTF Hub con WhatsApp →",
  "user.ltf.qr.toggle": "O escaneá el código QR con tu teléfono",
  "user.ltf.qr.caption": "Abre un chat de WhatsApp con LTF Hub",
  "user.ltf.qr.alt": "Código QR para abrir LTF Hub en WhatsApp",
  "user.ltf.legal.intro": "Al continuar, aceptás nuestra ",
  "user.ltf.legal.privacy": "Política de Privacidad",
  "user.ltf.legal.and": " y los ",
  "user.ltf.legal.terms": "Términos",
  "user.ltf.encryption":
    "Los mensajes están cifrados de extremo a extremo. Tu número solo se comparte con las personas que elijas.",
  "user.eventLanding.headline": "Conecta con las personas indicadas",
  "user.eventLanding.lede":
    "Porter, tu agente, está aquí para ayudarte a encontrarlas.",
  "user.eventLanding.ledeWithCount":
    "Vienen {{count}} personas. Porter, tu agente, está aquí para ayudarte a encontrarlas.",
  "user.eventLanding.facesMore": "{{count}}",
  "user.eventLanding.steps.tellPorter": "Cuéntale a Porter por qué estás aquí",
  "user.eventLanding.steps.suggestions": "Recibe sugerencias pensadas para ti",
  "user.eventLanding.steps.connect":
    "Conecta por email o WhatsApp, cuando ambos digan que sí.",
  "user.eventLanding.organizedBy": "Organizado por",
  "user.eventLanding.supportedBy": "Con el apoyo de",
  "user.eventLanding.cta.openWhatsapp": "Empieza en WhatsApp",
  "user.eventLanding.desktopQr.title": "Escanea para empezar en WhatsApp",
  "user.eventLanding.desktopQr.caption":
    "Apunta la cámara de tu teléfono al código para abrir un chat con Porter.",
  "user.eventLanding.desktopQr.fallback": "Abrir WhatsApp en esta computadora",
  "user.eventLanding.tv.caption": "Escanea con tu teléfono para unirte",
  "user.eventLanding.tv.present": "Pantalla completa",
  "user.eventLanding.tv.exit": "Salir",
  "user.eventLanding.cta.scanQr": "O escanea un código QR con tu teléfono",
  "user.eventLanding.qrCaption": "Abre un chat de WhatsApp con Porter",
  "user.eventLanding.legal.intro": "Lo que le cuentas a Porter es privado.",
  "user.eventLanding.legal.body":
    "Al continuar aceptas nuestra {{privacy}} y nuestros {{terms}}.",
  "user.eventLanding.legal.privacyLabel": "Política de Privacidad",
  "user.eventLanding.legal.termsLabel": "Términos",
} as const satisfies TranslationDictionaryType;

// Compile-time assertion: Spanish must have same keys as English
export type AssertEsMatchesEnType = AssertMatchingPlaceholders<
  typeof en,
  typeof es
>;
